export default {
  version: 'VERSION'
};
